import { NgModule } from '@angular/core';
import { FlowsComponent } from './flows.component';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../../shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconComponent } from '../icon/icon.component';
import { CreateFlowModalModule } from '../create-flow-modal/create-flow-modal.module';
import { SendFlowToDeviceModalModule } from '../send-flow-to-device-modal/send-flow-to-device-modal.module';
import { EditDeviceNoteModalModule } from '../edit-device-note-modal/edit-device-note-modal.module';
import { ConfirmModalModule } from '../confirm-modal/confirm-modal.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [FlowsComponent],
    imports: [
        SharedModule,
        MatCardModule,
        MatExpansionModule,
        MatListModule,
        MatTableModule,
        MatButtonModule,
        MatTooltipModule,
        IconComponent,
        CreateFlowModalModule,
        SendFlowToDeviceModalModule,
        EditDeviceNoteModalModule,
        ConfirmModalModule,
        MatProgressSpinnerModule,
    ],
})
export class FlowsModule {}
